import React from 'react';

const TermCondPage = () => {
    return (
        <div>
            <h1>Terminos y Condiciones</h1>
        </div>
    );
};

export default TermCondPage;